import { Component, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { DefaultEditor } from "ng2-smart-table";

@Component({
  template: `
    <input
      [ngClass]="inputClass"
      #name
      class="form-control short-input"
      [name]="cell.getId()"
      [disabled]="!cell.isEditable()"
      [placeholder]="cell.getTitle()"
      (click)="onClick.emit($event)"
      (keyup)="updateValue()"
      (keydown.enter)="onEdited.emit($event)"
      (keydown.esc)="onStopEditing.emit()"
    /><br />
    ĐVT:
    <input
      [ngClass]="inputClass"
      #unitName
      class="form-control short-input"
      [name]="cell.getId()"
      [disabled]="!cell.isEditable()"
      [placeholder]="cell.getTitle()"
      (click)="onClick.emit($event)"
      (keyup)="updateValue()"
      (keydown.enter)="onEdited.emit($event)"
      (keydown.esc)="onStopEditing.emit()"
    />
    <div [hidden]="true" [innerHTML]="cell.getValue()" #htmlValue></div>
  `,
})
export class StbCustomEditorProductTitleComponent
  extends DefaultEditor
  implements AfterViewInit
{
  @ViewChild("name") name: ElementRef;
  @ViewChild("unitName") unitName: ElementRef;
  @ViewChild("htmlValue") htmlValue: ElementRef;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    if (this.cell.newValue !== "") {
      this.name.nativeElement.value = this.getUrlName();
      this.unitName.nativeElement.value = this.getAttribute();
    }
  }

  updateValue() {
    const unitName = this.unitName.nativeElement.value;
    const name = this.name.nativeElement.value;
    if (unitName != "") {
      this.cell.newValue = `<h6 unitName='${unitName}'>${name} (${unitName})</h6>`;
    } else {
      this.cell.newValue = `<h6 unitName='${unitName}'>${name}</h6>`;
    }
  }

  getUrlName(): string {
    return this.htmlValue.nativeElement.innerText;
  }

  getAttribute(): string {
    return this.htmlValue.nativeElement.querySelector("a").getAttribute("href");
  }
}
